module.exports = __webpack_public_path__ + "static/media/Encrypt.d2370cb3.svg";